import styles from './LoginActionCard.module.scss'
import LoginForm from './partials/LoginForm'
import cn from 'classnames'
import Link from 'next/link'
import ActionCardLayout from '@/layouts/ActionCardLayout'

function LoginActionCard({ className, redirectUrl = null, ...props }) {
  return (
    <ActionCardLayout
      className={cn(styles['root'], { [className]: className })}
      {...props}
    >
      <ActionCardLayout.Main className={cn(styles['root__main'])}>
        <h2>Inloggen</h2>

        <LoginForm
          className={cn(styles['form'])}
          redirectUrl={redirectUrl}
        />
      </ActionCardLayout.Main>

      <ActionCardLayout.Footer className={cn(styles['root__footer'])}>
        <ul>
          <li>
            <Link href="/wachtwoord-vergeten">Wachtwoord vergeten</Link>
          </li>
          <li>
            <Link href="/account-aanvragen">Account aanvragen</Link>
          </li>
        </ul>
      </ActionCardLayout.Footer>
    </ActionCardLayout>
  )
}

export default LoginActionCard
